import { FiltersPrediction } from 'src/types.d'

const initialState: FiltersPrediction = {
  alarmed: true,
  period: 'month'
}
export default (state = initialState, action) => {
  switch (action.type) {
    case 'filters/prediction/set':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
